import * as bumpActions from './bumpActions';
import * as bumpInstance from './bumpInstance';
import * as bumpInterface from './bumpInterface';
import bumpReducer from './bumpReducer';
import bumpSagas, { subscribeForBumpUpdates } from './bumpSagas';
import * as bumpSelectors from './bumpSelectors';
import * as bumpTypes from './bumpTypes';

bumpInterface.bumpInterfaceInit({
  open: bumpInstance.open,
  onOpen: bumpInstance.onOpen,
  send: bumpInstance.send,
  onMessage: bumpInstance.onMessage,
  onError: bumpInstance.onError,
  close: bumpInstance.close,
  onClose: bumpInstance.onClose,
  checkSocketConnection: bumpInstance.checkSocketConnection,
});

const { BUMP_REDUCER_KEY } = bumpTypes;

export {
  BUMP_REDUCER_KEY,
  bumpActions,
  bumpInterface,
  bumpReducer,
  bumpSagas,
  bumpSelectors,
  bumpTypes,
  subscribeForBumpUpdates,
};
